import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { ProbationReportForm } from "../../../components/report/form/ProbationReportForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Coach } from "../../../models/coach";
import type { ProbationReport } from "../../../models/reports/probationReport";
import { report_path, reports_path } from "../../../routes";

type ProbationReportEditProps = {
  probation_report: ProbationReport;
  coaches: Coach[];
};

export default function ProbationReportEdit({ probation_report, coaches }: ProbationReportEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(report_path, probation_report.id), values);
  return (
    <ContentShell title={`Bericht ${probation_report.title}`} onBack={() => router.get(pathWithYearContext(reports_path))}>
      <ProbationReportForm onSubmit={onSubmit} saveButtonLabel="Speichern" probationReport={probation_report} coaches={coaches} />
    </ContentShell>
  );
}
